import { computed, inject, Injectable, signal } from '@angular/core';
import { IUserHelperModule, EUserHelperID, IUserHelperConfig } from './user-helper.model';
import { ECMSContentRefCat, ECMSModuleType } from '../../../../Reusables/reusable-pages/cms/cms.model';
import { CMSService } from '../../../../Reusables/reusable-pages/cms/cms.service';
import { environment } from '../../../../../environments/environment';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserHelperService {
  readonly cmsService = inject(CMSService);
  protected readonly _modules = signal<IUserHelperModule[]>([
    { id: EUserHelperID.chat, label: 'Chat', icon: 'fa fa-mail-bulk' },
    { id: EUserHelperID.quote, label: 'Quote', icon: 'fa fa-clipboard-list' },
    { id: EUserHelperID.note, label: 'Notes', icon: 'fa fa-note-sticky' },
    { id: EUserHelperID.task, label: 'Tasks', icon: 'fa fa-list' },
    { id: EUserHelperID.notification, label: 'Notifications', icon: 'fa fa-bell' },
    {
      id: EUserHelperID.help,
      label: 'Help',
      icon: 'fa fa-question-circle',
    },
    { id: EUserHelperID.dictionary, label: 'Dictionary', icon: 'fa fa-book' },
    { id: EUserHelperID.suggestion, label: 'Suggestion', icon: 'fa fa-lightbulb' },
  ]);
  protected readonly _config = signal<IUserHelperConfig>({});
  readonly show = signal(false);
  // readonly show = signal(true);
  readonly showEntireModule = computed(() => environment.isLoggedIn());

  readonly config = computed(() => ({ ...this._config() }));
  readonly modules = computed(() => {
    const config = this._config() || {},
      ret: IUserHelperModule[] = [];
    for (const x of this._modules() || []) {
      if (config.hiddenModules?.[x.id]) continue;
      ret.push({ ...x, ...(config?.moduleProperties?.[x.id] || {}) });
    }
    return ret;
  });

  constructor() {
    // if(!environment.production)
    //   this.show.set(true)
  }

  updateConfig(config: Partial<IUserHelperConfig>) {
    this._config.update((map) => ({ ...map, ...config }));
  }

  searchHelp = (query: { path: string }) =>
    this.cmsService
      .getPageRelatedResources({
        applicationCode: this._config()?.applicationCode,
        moduleType: ECMSModuleType.help,
        refCat: ECMSContentRefCat.path,
        refId: query.path,
      })
      .then((r) => r?.filter((x) => !!x.content));

  toggle(show?: boolean) {
    if (show != null) this.show.set(show);
    else this.show.set(!this.show());
  }
}
